import {
  createContext,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react';
import { TraderOrderRankChartDataType } from '../OrderCountRankChart';
import useFetch from '../../../api/useFetch';
import {
  ChartByProdAmountPriceDataType,
  deliveryTypePercentGetApi,
  monthlyResultGetRequestApi,
  OrderAnalysisChartDataType,
  PercentWithTitleType,
  prodAmountPriceDataGetRequestApi,
  traderRankGetRequestApi,
} from '../../../api/apiConfig';
import { formatDashFormToEightDigitString } from '../../../function/replaceString';
import { OrderAmountRankChart } from '../OrderAmountRankChart';
import { ChartContextEssType, ChartContextType } from './chartContextType';

export const DeliveryTypePercentageProvider = ({
  fetchCount,
  startDt,
  endDt,
  children,
}: {
  fetchCount: number;
  startDt: string;
  endDt: string;
  children: React.ReactNode;
}) => {
  const [data, setData] = useState<PercentWithTitleType[]>([]);

  const [filteredData, setFilteredData] = useState<PercentWithTitleType[]>([]);

  const [pageIndex, setPageIndex] = useState<number>(1); // 현재 페이지

  const itemsPerPage = 10;

  const totalPage = Math.ceil(data.length / itemsPerPage); // 총 페이지 수

  const { fetch: fetchDeliveryTypePercentGetApi } = useFetch({
    fetchFunction: deliveryTypePercentGetApi,
    onSuccess: (data: PercentWithTitleType[]) => {
      // sortedData를 percent 내림차순으로 정렬
      const sortedData = [...data].sort((a, b) => b.percent - a.percent);

      //   const paginatedData = sortedData.slice(0, itemsPerPage); // 첫 페이지 데이터

      setData(sortedData);
      //   setFilteredData(paginatedData);
    },
  });

  useEffect(() => {
    fetchCount > 0 &&
      fetchDeliveryTypePercentGetApi({
        startDt: formatDashFormToEightDigitString(startDt),
        endDt: formatDashFormToEightDigitString(endDt),
      });
  }, [fetchCount]);

  // 페이지 번호에 따라 데이터 필터링
  const setFilterCriteria = (pageIndex: number) => {
    setPageIndex(pageIndex);
    const startIdx = (pageIndex - 1) * itemsPerPage;
    const endIdx = Math.min(pageIndex * itemsPerPage, data.length); // endIdx가 data.length를 넘지 않도록 처리

    setFilteredData(data.slice(startIdx, endIdx)); // 해당 페이지 데이터만 필터링
  };

  return (
    <DeliveryTypePercentageContext.Provider
      value={{
        data: data,
        filteredData: filteredData,
        startDt: startDt,
        endDt: endDt,
      }}
    >
      {children}
    </DeliveryTypePercentageContext.Provider>
  );
};

const DeliveryTypePercentageContext = createContext<ChartContextEssType | null>(
  null
);

export const useDeliveryTypePercentageData = () => {
  const context = useContext(DeliveryTypePercentageContext);
  if (!context) {
    throw new Error(
      'useOrderAmountRankChart must be used within OrderAmountRankChartProvider'
    );
  }
  return context;
};
